import { STYLE_LIST } from '../../config/dataConfig/FJImageToImageData';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJActionModal from './FJActionModal';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJS3Config from '../../config/FJS3Config';
import {
    setSliceGenerateQuantityAction,
    setSliceUploadImageInfoAction,
    setSlicePromptAction,
    IMAGE_TO_IMAGE_USE_CREDIT,
    setSliceOpenPromptInputAction,
    setSliceIsExpandEditAction,
    setSlicePrivacySettingAction,
    setSliceCreationListAction,
    setSliceTaskStatusAction,
    setSliceSelectedStyleAction,
    setSliceFreeNumCreationAction,
} from '../slices/FJSliceImageToImage';
import FJActionCommon from './FJActionCommon';
import FJConfig from '../../config/FJConfig';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJImageToImageConfig from '../../config/appConfig/FJImageToImageConfig.js';

let f_eventIds = null;
let f_currentTaskId = null;

const _uploadFileAndCompressed = async src => {
    const blob = await FJCompressedImageStore.simpleCompressImage(src);
    if (!blob) return '';
    const id = await FJUtil.hashEncode(blob);
    const key = FJConfig.originalImageKey + `${id}.png`;
    const result = await FJImageStore.upLoadFileToS3Async(blob, key);
    if (!result) return '';
    return FJS3Config.S3_SERVER_HOST + key;
};

const _limitJudgment = (hasFreeCreation, creditNumber, generateQuantity, isPro, isExpensive) => {
    // 单张消耗积分
    const consumePointsPerTicket = IMAGE_TO_IMAGE_USE_CREDIT * (isPro || isExpensive ? 2 : 1);

    if (generateQuantity * consumePointsPerTicket <= creditNumber) {
        //判断积分
        return true;
    } else if (hasFreeCreation && generateQuantity < 3) {
        //判断免费
        return true;
    } else return false;
};

const _checkIsCurrentTask = id => {
    return id === f_currentTaskId;
};
// 新chrome模型 比例
const _getRatio = (width, height) => {
    const ratio = width / height;
    return ratio > 1 ? '3:2' : ratio < 1 ? '2:3' : '1:1';
};
const FJActionImageToImage = {
    updateUseFreeLimitAction: function (info) {
        return async dispatch => {
            dispatch(setSliceFreeNumCreationAction(info[FJImageToImageConfig.freeLimitType]));
        };
    },
    editHistoryItemAction: function (data = {}) {
        return async dispatch => {
            const { prompt, originalUrl, style } = data;
            dispatch(setSlicePromptAction(prompt));
            dispatch(this.updateGenerateQuantityAction(1));
            dispatch(setSliceSelectedStyleAction(style));
            const imgFile = await FJUtil.downloadImageCacheAvoidance(originalUrl);
            if (imgFile) {
                dispatch(this.uploadImageAction(imgFile));
            }
        };
    },
    setCreationListAction: function (list) {
        return dispatch => {
            dispatch(setSliceCreationListAction(list));
        };
    },
    setTaskStatusAction: function (value) {
        return dispatch => {
            dispatch(setSliceTaskStatusAction(value));
        };
    },
    setPrivacySettingAction: function (value) {
        return dispatch => {
            dispatch(setSlicePrivacySettingAction(value));
        };
    },
    resetAction: function () {
        return dispatch => {
            dispatch(setSlicePromptAction(''));
            dispatch(setSliceUploadImageInfoAction({}));
            dispatch(setSliceOpenPromptInputAction(false));
            // dispatch(setSliceGenerateQuantityAction(2));
            // dispatch(setSliceSelectStyleCategoryAction(0));
            // dispatch(setSliceSelectedStyleAction('green-art'));
        };
    },

    uploadImageAction: function (file, callback = () => {}, skipTranscoded = false) {
        return async dispatch => {
            const format = file.type;
            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            const __imageError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                FJUtil.eaLog('img to img upload fail', { format });
            };

            if (!isImage) {
                if (skipTranscoded) {
                    __imageError();
                    return;
                }
                try {
                    // 使用转码功能
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    dispatch(FJActionImageToImage.uploadImageAction(newFiles[0], callback));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    if (e.cause === FJConstant.CANCELLED) return;
                    FJUtil.eaLog('img to img upload fail', { format });
                    return;
                }
            }
            // 直接处理支持的文件
            FJUtil.loadImageFile(
                file,
                img => {
                    const info = {
                        src: img.src,
                        width: img.width,
                        height: img.height,
                        name: file.name,
                    };
                    dispatch(setSliceUploadImageInfoAction(info));
                    const resolution = img.width + ' * ' + img.height;
                    FJUtil.eaLog('img to img upload success', { format, resolution });
                    callback();
                },
                __imageError,
            );
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const { size, name, id } = options;
            const info = {
                name: name,
                src: url,
                width: size.width,
                height: size.height,
                id: id,
            };
            dispatch(setSliceUploadImageInfoAction(info));
        };
    },
    generateAction: function (options = {}) {
        return async (dispatch, getState) => {
            let { generateQuantity, prompt, selectedStyle, uploadImageInfo, privacyStatus } = getState().imageToImage;

            let { creditNumber, freeNumCreation } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;
            const { paramCount, paramPrompt, paramStyle, paramImageInfo, paramIsUploadS3 } = options;
            let isUploadS3 = paramIsUploadS3 || false;

            paramPrompt && (prompt = paramPrompt);
            paramStyle && (selectedStyle = paramStyle);
            paramImageInfo && (uploadImageInfo = paramImageInfo);
            paramCount && (generateQuantity = paramCount);

            const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
            const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
            let _startTime = new Date().getTime();
            const currentTaskId = new Date().getTime();
            f_currentTaskId = currentTaskId;
            f_eventIds = null;

            // 单张消耗积分
            const consumePointsPerTicket =
                IMAGE_TO_IMAGE_USE_CREDIT * (styleInfo.isPro || styleInfo.isExpensive ? 2 : 1);

            const isUseFree =
                hasFreeCreation && generateQuantity * consumePointsPerTicket > creditNumber && generateQuantity < 3;
            const buryData = {
                number: generateQuantity,
                style_model: selectedStyle,
                type: isUseFree ? 'free trail' : 'use credit',
            };
            FJUtil.eaLog('img to img click generate', buryData);

            if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
                FJUtil.eaLog('AI Tools guide AB generate click 2025.4.14', {
                    tool: 'image to image',
                    AB: FJUtil.getAB(),
                });
            }

            if (!uploadImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }
            let imageUrl = '';
            const placeHolderList = FJUtil.createPlaceHolderList({
                count: generateQuantity,
                uploadImageInfo,
                selectedStyle,
                prompt,
                isUploadS3,
                generateInfo: {
                    style: selectedStyle,
                    prompt,
                },
            });
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));
            const __errorToInitStatus = () => {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(setSliceCreationListAction([]));
            };
            const __errorAndReLoad = errorCode => {
                const creationList = getState().imageToImage.creationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                    errorCode,
                }));
                dispatch(setSliceCreationListAction(reLoadList));
                dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
            };

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                    FJUtil.eaLog('img to img click generate fail', buryData);
                },
                loginCallback: () => {
                    FJUtil.setIsNeedGenerateInImageToImage(true);
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __errorToInitStatus();
                return;
            }

            if (!_checkIsCurrentTask(currentTaskId)) return;

            const isExceedCredits = generateQuantity * consumePointsPerTicket > creditNumber;
            const isFree = hasFreeCreation && isExceedCredits;

            if (
                (isFree && (generateQuantity > 2 || styleInfo.isPro || styleInfo.isExpensive)) ||
                (!hasFreeCreation && isExceedCredits)
            ) {
                dispatch(FJActionModal.showUpgradeModalAction());
                __errorToInitStatus();
                return;
            }

            try {
                if (isUploadS3) {
                    imageUrl = uploadImageInfo.src;
                } else {
                    imageUrl = await _uploadFileAndCompressed(uploadImageInfo.src);
                    isUploadS3 = true;
                }
                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!imageUrl) {
                    __errorToInitStatus();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-please-try-again'), 'error');
                    return;
                }

                let usePrompt = prompt;
                if (prompt) {
                    const postData = [{ text: prompt }];
                    const result = await FJNetworkStore.translateValueToLanguage(postData);
                    usePrompt = result[0].translations[0].text;
                }

                const __request = async () => {
                    return await FJNetworkStore.imgToImg({
                        image: imageUrl,
                        numOutputs: generateQuantity,
                        prompt: usePrompt,
                        originalPrompt: prompt,
                        style: selectedStyle,
                        ratio: _getRatio(uploadImageInfo.width, uploadImageInfo.height),
                        privacyStatus,
                    });
                };
                const eventId = await FJActionCommon.createRequestTask(__request, dispatch);

                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!eventId) {
                    __errorToInitStatus();
                    return;
                }
                if (!Array.isArray(eventId)) {
                    f_eventIds = [eventId];
                } else {
                    f_eventIds = eventId;
                }
                FJUtil.eaLog('ai generate community privacy settings', {
                    setting: privacyStatus,
                });
                FJUtil.updateAllCreditInfo();
                dispatch(setSliceIsExpandEditAction(false));
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                const callback = data => {
                    const { type, waitingEndTime, errorCode } = data;
                    let _endTime = new Date().getTime();
                    const queuingDuration = FJUtil.getTimeDiff(_startTime, waitingEndTime);
                    const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);
                    queuingDuration && (buryData['queuing duration'] = queuingDuration);
                    generatingDuration && (buryData['generating duration'] = generatingDuration);
                    if (type === FJConstant.ERROR) {
                        FJUtil.eaLog('img to img click generate fail', buryData);
                        __errorAndReLoad(errorCode);
                    } else if (type === FJConstant.SUCCESS) {
                        if (!window.isEditPage) {
                            isUseFree && dispatch(FJActionModal.showAnimateImageModalAction());
                        }
                        FJUtil.eaLog('img to img click generate success', buryData);
                        FJUtil.setLocalStorage();
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };
                dispatch(
                    FJActionCommon.pollingTaskAction(f_eventIds, {
                        callback,
                        progressNumber: generateQuantity,
                        isUseFree,
                        appType: FJAppConstant.IMAGE_TO_IMAGE,
                    }),
                );
            } catch (e) {
                __errorAndReLoad(501);
                FJUtil.eaLog('img to img click generate fail', buryData);
            }
        };
    },
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().imageToImage;
            const item = creationList.find(item => item.id === id);

            const data = {
                paramCount: creationList.length,
                paramPrompt: item.generateInfo.prompt,
                paramStyle: item.generateInfo.style,
                paramImageInfo: {
                    src: item.uploadS3Url || item.originalUrl,
                    width: item.width,
                    height: item.height,
                },
                paramIsUploadS3: item.isUploadS3,
            };
            dispatch(FJActionImageToImage.generateAction(data));
        };
    },
    updateGenerateQuantityAction: function (number) {
        return (dispatch, getState) => {
            const { generateQuantity, selectedStyle } = getState().imageToImage;
            const { freeNumCreation, creditNumber } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;

            const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
            const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};

            if (
                !_limitJudgment(hasFreeCreation, creditNumber, number, styleInfo.isPro, styleInfo.isExpensive) &&
                number > generateQuantity &&
                FJUtil.isLogin()
            ) {
                dispatch(FJActionModal.showUpgradeModalAction());
                return;
            }
            dispatch(setSliceGenerateQuantityAction(number));
        };
    },
    cancelTaskAction: function () {
        return async dispatch => {
            try {
                f_currentTaskId = null;
                f_eventIds && f_eventIds.length > 0 && (await FJNetworkStore.cancelTask(f_eventIds.join()));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },
    loadImageToImagePageAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                if (!window.isEditPage) {
                    const url = location.origin + location.pathname;
                    FJUtil.changeLocation(url);
                }
                window.localStorage.removeItem(recId);

                dispatch(FJActionImageToImage.handleRecInfoAction(recIdInfo));
            } else {
                // TODO 社区版本去掉
                // dispatch(FJActionGuide.showImageToImageGuideModal());
            }
        };
    },
    handleRecInfoAction: function (recIdInfo) {
        return async dispatch => {
            const { fileList, avator, fromType } = recIdInfo;

            if (fromType === FJConstant.COMMUNITY) {
                dispatch(FJActionCommon.onRecreateAction(recIdInfo));
                return;
            }

            if (fileList) {
                const fileInfo = fileList[0]?.info;
                if (!fileInfo) return;

                const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                dispatch(
                    FJActionImageToImage.uploadImageAction(
                        file,
                        () => {
                            const hasStyle = !!STYLE_LIST.find(ca =>
                                ca.list.find(item => item.value === recIdInfo?.style),
                            );
                            if (hasStyle) {
                                dispatch(FJActionImageToImage.generateAction());
                            }
                        },
                        true,
                    ),
                );
            } else if (avator) {
                const blob = await FJUtil.getBlobByUrl(avator);
                dispatch(
                    FJActionImageToImage.uploadImageAction(
                        blob,
                        () => {
                            const hasStyle = !!STYLE_LIST.find(ca =>
                                ca.list.find(item => item.value === recIdInfo?.style),
                            );
                            if (hasStyle) {
                                dispatch(FJActionImageToImage.generateAction());
                            }
                        },
                        true,
                    ),
                );
            }
        };
    },

    /**
     * @desc 下载所有创作
     * @returns
     */
    downloadAllCreationAction: function (callback) {
        return async (dispatch, getState) => {
            const { creationList } = getState().imageToImage;
            if (creationList.length === 0) return;
            const ids = creationList.map(item => item.id);
            dispatch(FJActionCommon.multiDownloadAction(ids, 'creation', callback));
        };
    },
    animateImageAction: function (isModel = false) {
        return async (dispatch, getState) => {
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai_image_tool_to_video_generator_click', {
                tool: isModel ? tool + ' window' : tool + ' banner',
            });

            const creationList = getState().imageToImage.creationList;
            const avator = creationList[0]?.imgUrl || '';
            if (!avator) return;
            const recId = `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem(recId, JSON.stringify({ avator }));
            const toolName = FJUtil.getAIToolHref(FJAIVideoGeneratorConfig.currentMenuName);
            const url = FJUtil.getCurrentUrl() + toolName.slice(1) + '?rec_id=' + recId;

            window.open(url, '_blank');
        };
    },
};
export default FJActionImageToImage;
